"use strict";

/* A service / model */
_BannerFlowApp.factory("Setting", function () {
    return {
        _getSettings: function () {
            try {
                return JSON.parse(window.localStorage.getItem("settings")) || {};
            } catch (e) {
                return {};
            }
        },
        Get: function (key) {
            return this._getSettings()[key];
        },
        Set: function (key, value) {
            var settings = this._getSettings();
            settings[key] = value;
            try {
                window.localStorage.setItem("settings", JSON.stringify(settings));
            } catch (e) {
                console.error(e);
            }
        }
    };
});
